import TamanioUpdate from './TamanioUpdate'
export {TamanioUpdate}
export default TamanioUpdate
